<template>
    <div class="er_main">
        <div class="mainbg">
            <div class="ml">
                <ul class="mlnav">
                    <li v-for="(item, index) in menuItems" :key="index"
                        @mouseover="handleMouseOver(index)"
                        @mouseout="handleMouseOut(index)"
                        :class="{ 'navs': isActiveIndex === index }" >
                        <a  :class="{ 'hover': isActiveIndex === index }" @click="gotoHref(item.fieldCode)">{{item.title}}</a>
                    </li>
                </ul>
            </div>
            <div class="mr">
                <div class="bt2">
                    <strong>{{contentObj.title}}</strong>
                    <p>您的位置：<a @click="goto('/')"  style="cursor:pointer">首页</a> - <a @click="goto(contentObj.parentCode)" style="cursor:pointer">{{contentObj.parentName}}</a> -
                        <span style="color:#036d6a;font:12px 宋体;">{{contentObj.title}}</span>
                    </p>
                </div>
                <div class="abnr">
                    <div class="new_con">
                        <h1 class="new_tit">
                            <strong>{{contentObj.title}}</strong>
                        </h1>
                        <div id="content_page" v-html="contentObj.content">

                        </div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "RiskItem",
        props: {
            datalist: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                menuItems: [
                    {
                        label: '风险控制',
                        href:'risk',
                        menuClase:'nav1',
                    },
                    {
                        label: '资讯管理',
                        href:'Advisory.aspx',
                        menuClase:'nav2',
                    },
                    {
                        label: '资讯管理',
                        href:'Advisory.aspx',
                        menuClase:'nav3',
                    },
                    {
                        label: '资讯管理',
                        href:'Outsourcing_list.aspx',
                        menuClase:'nav4',
                    },
                    {
                        label: '关于我们',
                        href:'Advisory.aspx',
                        menuClase:'nav5',
                    },
                ],
                isActiveIndex: null, // 用于跟踪当前激活的菜单项索引
                contentObj:{},
            }
        },
        mounted() {

        },
        methods: {
            handleMouseOver(index) {
                this.isActiveIndex = index;
            },
            handleMouseOut(index) {
                if (this.isActiveIndex === index) {
                    //this.isActiveIndex = null;
                }
            },
            goto(url){
                url = url.replace('/','');
                this.$router.push(url);
            },
            gotoHref(url){
                url = '/' + url;
                this.$router.push(url);
            },
        },
        watch: {
            datalist: {
                handler(newVal, oldVal) {
                    let data = newVal.menuList;
                    this.menuItems = newVal.menuList;
                    this.contentObj = newVal;
                    //得到激活项
                    if(data && data.length >0){
                        let checkCode = newVal.code.replace("/",'');
                        for(let i=0;i< data.length;i++){
                            let menuObj = data[i];
                            let mcode = menuObj.fieldCode.replace("/",'');
                            if(checkCode == mcode){
                                this.isActiveIndex = i;
                                break;
                            }
                        }
                    }
                },
                immediate: true
            },
        }
    }
</script>

<style lang="scss" scoped >
    *{ margin:0; padding:0;}
    .body{ color:#666; font:12px "宋体";background:#daecec;}
    .er_main{width:968px;background:url("../../../assets/images/bg_left.jpg") repeat-y left top;margin:0 auto;}
    .mainbg{height:auto!important;min-height:256px;height:256px;background:url("../../../assets/images/bg_neiye.jpg") no-repeat left bottom;}
    .ml{height:auto !important;min-height:200px;height:200px;padding:5px 3px 0px 0px;width:213px;float:left;background:url("../../../assets/images/bg_touyin.jpg") no-repeat left top;}
    .mlnav{height:auto!Important;height:50px;min-height:50px;padding:9px 5px 33px 13px;width:200px;}
    .mlnav li{cursor: pointer; line-height:35px;padding-left:10px;background:url("../../../assets/images/bg_left1.jpg") no-repeat left bottom;height:auto!Important;height:35px;min-height:35px;}
    .mlnav li a{padding:0 0 0 15px;	background:url("../../../assets/images/list1.jpg") no-repeat left 2px;color:#666;line-height:35px;}
    .mlnav li a:hover,.mlnav li a.hover{color:#006765;text-decoration:none;background:url("../../../assets/images/list2.jpg") no-repeat left 2px;}
    .malepu{width:213px;height:auto !important;min-height:67px;height:67px;text-align:center;padding-bottom:20px; display:none;}
    .malepu img{border:0;}
    .mr{width:747px;height:auto!important;height:400px;min-height:400px;float:left;/*padding:0 20px 0 20px;*/position:relative;}
    .bt2{height:35px;border-bottom:1px solid #dbdbdb;padding-left:13px;position:relative;}
    .bt2 strong{font-size:14px;color:#036d6a;background:url("../../../assets/images/dot_2.jpg") no-repeat left 14px;width:500px;display:block;padding-left:14px;/*line-height:35px;*/padding-top:12px;}
    .bt2 p{position:absolute;right:4px;top:14px;color:#666;}
    .bt2 p a{color:#666;}
    .bt2 p a:hover{color:#036d6a;text-decoration:none;}
    .abnr{line-height:24px;padding:20px;height:auto!Important;height:200px;min-height:200px;}
    .clear {clear: both;height: 0;overflow: hidden;}
    a {
        color: #666;
        text-decoration: none;
        blr: expression(this.onFocus=this.blur());
        outline: none;
    }
    .adv_gd{ height:auto!Important; height:205px; min-height:205px; margin:0 auto;padding:10px 0 20px; margin:0 10px;}
    .adv_gd img{float:left;}
    .adv_lei{width:300px;height:190px;background:url("../../../assets/images/gl_08.jpg") no-repeat left center;float:left;padding-top:15px;}
    .adv_lei li{width:198px;height:30px;padding-bottom:20px;padding-left:88px;}
    .adv_lei li a{width:198px;height:30px;display:block;}
    .adv1{background:url("../../../assets/images/gl_1.jpg") no-repeat left top;}
    .adv2{background:url("../../../assets/images/gl_2.jpg") no-repeat left top;}
    .adv3{background:url("../../../assets/images/gl_3.jpg") no-repeat left top;}
    .adv4{background:url("../../../assets/images/gl_4.jpg") no-repeat left top;}
    .adv_lei li a:hover{background-position:left bottom;}
    .new_list{width:678px;height:auto !important;	min-height:10px;height:100px;padding-bottom:15px;margin:0 auto;}
    .new_list li{width:678px;height:30px;border-bottom:#e5e5e5 1px solid;line-height:30px; position:relative;}
    .new_list li a{text-decoration:none;}
    .new_list li span{ position:absolute; right:0; top:0;}
    .new_con{width:678px;height:auto !important;min-height:200px;height:200px;line-height:25px;margin:0 auto;padding-bottom:10px;}
    .new_tit{font-size:16px;text-align:center;border-bottom:1px solid #dbdbdb;line-height:58px;margin-bottom:25px;}
    .title01{font-size:16px;text-align:center;border-bottom:1px solid #dbdbdb;line-height:58px;}
    .datebt{ height:25px; line-height:25px; margin-bottom:20px; text-align:center; color:#666; font-size:12px; border-bottom:1px solid #dbdbdb;}
</style>
